import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { PPUIPageHeader, PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import FailedLoadBanner from '../../components/common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../../components/common/loading/FallbackErrorBanner';
import SegmentedTabs from '../../components/layout/tabs/SegmentedTabs';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import { SCREENS } from '../../constants/tracking/Screens';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { usePageParams } from '../../hooks/usePageParams';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasPricingAndPurchasingFailedSelector } from '../../selectors/LoadingStateSelectors';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import PowerOfHubSpotSection from './PowerOfHubSpotSection';
import ProductsSection from './ProductsSection';
import SuiteSection from './suite-section/SuiteSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SplashPage = () => {
  useTrackRetail();
  useDocumentTitle('default');
  const isAppReady = useGlobalLoading();
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const isAppAuth = useSelector(isAppAuthSelector);
  const {
    tab = ENTERPRISE
  } = usePageParams();
  useEffect(() => {
    trackPageView(Object.assign({
      screen: SCREENS.SPLASH
    }, !isAppAuth && {
      tab
    }));
  }, [isAppAuth, tab]);
  return /*#__PURE__*/_jsxs("div", {
    children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
      name: "SPLASH_PAGE"
    }), /*#__PURE__*/_jsx(FailedLoadBanner, {
      hasFailed: hasPricingAndPurchasingFailed
    }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), !isAppAuth && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Flex, {
        position: "relative",
        blockSize: "250px",
        justifyContent: "center",
        alignItems: "center",
        paddingBlockStart: "800",
        children: /*#__PURE__*/_jsxs(PPUIPageHeader, {
          children: [/*#__PURE__*/_jsx(PageTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "splash-page.header.title"
            })
          }), /*#__PURE__*/_jsx(PageSubTitle, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "splash-page.header.subtitle"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(SegmentedTabs, {
        selectedTab: tab,
        path: "/splash",
        bordered: true,
        use: "enclosed-shaded"
      })]
    }), /*#__PURE__*/_jsxs("main", {
      role: "main",
      children: [tab === ENTERPRISE ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ProductsSection, {
          selectedTab: tab,
          sectionProps: {
            use: 'shaded'
          }
        }), /*#__PURE__*/_jsx(SuiteSection, {
          selectedTab: tab
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SuiteSection, {
          selectedTab: tab,
          sectionProps: {
            use: 'shaded'
          }
        }), /*#__PURE__*/_jsx(ProductsSection, {
          selectedTab: tab
        })]
      }), /*#__PURE__*/_jsx(PowerOfHubSpotSection, {
        sourceId: "pricing-pages-splash-page",
        selectedTab: tab
      })]
    })]
  });
};
export default SplashPage;